<script>
    import Button from "$lib/Button.svelte";
</script>

<Button color="secondary" on:click {...$$restProps}>
    <slot></slot>
</Button>
